// @flow
import types from './verandaCalculatorConstants';

const INIT_STATE = {
    // Options for dropdowns
    options: {
        roofTypes: [],
        materialColorTypes: [],
        models: [],
        frameColors: [],
        ledTypes: [],
        ledColors: [],
        // Add other options as needed
    },
    // Calculation results
    calculatedMaterials: [], // To store the table data
    // Status flags
    loading: false,
    success: null, // To store success messages/flags
    error: null    // To store error messages/flags
};

const VerandaCalculator = (state = INIT_STATE, action) => {
    switch (action.type) {
        case types.CLEAR_STATE:
            return {
                ...INIT_STATE
            };

        case types.RESET_CALCULATOR:
             // Resets calculation results and status flags, keeps options
            return {
                ...state, // Keep existing options
                calculatedMaterials: [],
                loading: false,
                success: null,
                error: null
            };

        // --- Option Fetching ---
        case types.GET_VERANDA_OPTIONS:
            return {
                ...state,
                loading: true,
                error: null, // Clear previous errors
                success: null
            };
        case types.GET_VERANDA_OPTIONS_SUCCESS:
            return {
                ...state,
                loading: false,
                // Assuming payload is an object like { materialTypes: [], ... }
                options: { ...state.options, ...action.payload },
                error: null
            };
        case types.GET_VERANDA_OPTIONS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload // Store error info
            };

        // --- Calculation ---
        case types.CALCULATE_VERANDA:
            return {
                ...state,
                loading: true,
                error: null,
                success: null,
                calculatedMaterials: [] // Clear previous results before new calculation
            };
        case types.CALCULATE_VERANDA_SUCCESS:
            return {
                ...state,
                loading: false,
                // Assuming payload.data contains the list for the table, e.g., payload.data.materialsList
                calculatedMaterials: action.payload?.data || [],
                success: 'VERANDA_CALCULATOR.CALCULATION_SUCCESS', // Example success message key for intl
                error: null
            };
        case types.CALCULATE_VERANDA_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload, // Store error info
                calculatedMaterials: [] // Ensure results are empty on failure
            };

        default:
            return state;
    }
};

export default VerandaCalculator;